import styled from "styled-components";
import Image from "next/image";
import ErrorFlyIcon from "@/images/icon/error-fly-icon.png";

type Props = {
    className: string
    errorMessge: string
    onEmit: ()=> void
}

const ErrorTryAgainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 120px;
    height: 120px;
    margin-bottom: 12px;
  }
  .show-message {
    color: rgba(194, 196, 204, 1);
    font-size: 14px;
    margin-bottom: 12px;
  }
  .btn {
    padding: 6px 12px;
    color: rgba(26, 26, 26, 1);
    border-radius: 4px;
    border: 1px solid rgba(136, 139, 148, 1);
    cursor: pointer;
    z-index: 66;
    font-size: 12px;
  }
`
export const ErrorTryAgain = ({className, errorMessge = 'Error, please try again', onEmit}: Props)=>  {

    return <ErrorTryAgainWrapper className={className}>
        <Image src={ErrorFlyIcon} width={120} height={120}/>
        <p className="show-message">{errorMessge}</p>
        <div className="btn" onClick={onEmit}>Try again</div>
    </ErrorTryAgainWrapper>
}